/*
 * Gaming Arcade Frontend
 * Copyright (C) 2022, Zelta Tech (https://zeltatech.com)
 */

import { useMoralis } from "react-moralis";
import { useEffect, useState, useRef, useContext } from "react";
import config from "../src/config/config";
import { UserLogin } from "../src/GameServices/GameServices";
import { WalletContext } from "./component/Context/noteContext";
import { useAuthContext } from "./AuthContext";
import { profileDetails } from "../src/GameServices/GameServices";
// import SignClient from "@walletconnect/sign-client";

// import {socketmessage} from "./socket"

function useAuth() {
  const {
    authenticate,
    Moralis,
    logout,
    isWeb3Enabled,
    isAuthenticated,
    enableWeb3,
    chainId,
  } = useMoralis();

  const { walletConnection, setWalletConnection } = useContext(WalletContext);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMounted = useState(false);
  const [walletBalance, setWalletBalance] = useState();
  const { setErrorState, errorState } = useAuthContext();

  useEffect(() => {
    try {
      setLoading(true);
      Moralis.start({
        serverUrl: config.moralisURL,
        appId: config.moralisAPIKey,
      }).then((e) => {
        setLoggedInUser(Moralis?.User?.current()?.attributes?.ethAddress);
      });

      if (Moralis?.User?.current()?.attributes?.ethAddress) {
        setLoading(false);
        const options = {
          chain: "matic",
          address: Moralis?.User?.current()?.attributes?.ethAddress,
        };
        Moralis.Web3API.account.getNativeBalance(options).then((balance) => {
          console.log("user details ",balance)
          setWalletBalance(balance);
        });
        profileData(Moralis?.User?.current()?.attributes?.ethAddress);
      }
      
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (!isWeb3Enabled) {
      enableWeb3();
    }
  }, [chainId]);
  const profileData = async (id) => {
    let data = localStorage.getItem("global_data");
    if (data === undefined || data === null) {
      let response = await profileDetails(id);
      localStorage.setItem("global_data", JSON.stringify(response));
      console.log(response);
    }
  };

  async function authWallectConnect() {
    
    let data = await authenticate({
      provider: "walletconnect",
      projectId: "ef14718f89bdf36ee17df211ae274f84",
      chainId: config.selectedChainId,
      signingMessage: "Connected using walletconnect, Welcome!",
    }).then((user) => {
      // console.log("logged in user", user.attributes.ethAddress)
      LoginHandler(user.attributes.ethAddress);
      return user.attributes.ethAddress;
    });
    setLoggedInUser(data);
  }
  // console.log(loggedInUser, "loggedInUserloggedInUserloggedInUserloggedInUserloggedInUserloggedInUserloggedInUserloggedInUserloggedInUserloggedInUser");

  const Login = async () => {
    // console.log("ppppppppppppppppppp", !loggedInUser);
    isMounted.current = true;
    if (isMounted.current) {
      if (Moralis.User.current()) {
        // console.log("NNNNNNNNNNNNNNNNNN", Moralis.User.current());
        setLoggedInUser(Moralis.User.current().attributes.ethAddress);
        localStorage.setItem(
          "user_id",
          Moralis.User.current().attributes.ethAddress
        );
      }

      if (!Moralis.User.current()) {
        if (typeof window.ethereum !== "undefined") {
          // console.log("MetaMask is installed!");
          await authenticate({ signingMessage: "Log in using Moralis" })
            .then(async function (user) {
              setLoggedInUser(user.attributes.ethAddress);
              Moralis.User.currentAsync().then(function (user) {
                localStorage.setItem("user_id", user.attributes.ethAddress);
              });
              setWalletConnection(true);
              // socketmessage({player: user.attributes.ethAddress, name: "abcd"},"connectPlayer")
              LoginHandler(user.attributes.ethAddress);
              setErrorState(false);
              // console.log(isAuthenticated);
            })
            .catch(function (error) {
              // console.log(error);
            });
        } else {
          // console.log("Connecting using walletConnect");
          await authWallectConnect()
            .then(async function (user) {
              setLoggedInUser(user.attributes.ethAddress);
              LoginHandler(user.attributes.ethAddress);
              // console.log("logged in user:", data);
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        //TODO: Fetch referral address from backend and store it in localstorage.
      } else {
        console.log("QQQQQQQQQQQQQQQQQQQQQQQQQ");
      }
    } else {
      isMounted.current = true;
    }
  };
  const LoginHandler = async (user_addr) => {
    profileData(Moralis?.User?.current()?.attributes?.ethAddress);
    setWalletConnection(true);
    let payload = {
      address: user_addr,
    };
    let referee_address = localStorage.getItem("referAddress");
    if (referee_address !== null) {
      payload.referee_address = referee_address;
    } else {
      payload.referee_address = "";
    }

    let { data } = await UserLogin(payload);
    localStorage.setItem("refferralLink", data?.referral_link);
    setWalletConnection(true);
  };
  const logOut = async () => {
    await logout();
    localStorage.clear();
    setLoggedInUser(null);
  };

  return {
    isWeb3Enabled,
    Moralis,
    logOut,
    Login,
    loggedInUser,
    loading,
    isAuthenticated,
    chainId,
    walletBalance,
  };
}

export default useAuth;
